import { Box } from "@mui/material";
import { KpiCard } from "../../../mui";
import { Icon } from "../../../mui/icons";

export type MetricCell = {
  label: string;
  value: string;
  unit?: string;
  sub: string;
  valueColor?: string;
  icon: string;
  tileBg: string;
  tileColor: string;
};

export function MetricStrip({ cells }: { cells: MetricCell[] }) {
  return (
    <Box sx={{ display: "flex", gap: "14px" }}>
      {cells.map((m) => (
        <KpiCard
          key={m.label}
          label={m.label}
          value={m.value}
          unit={m.unit}
          hint={m.sub}
          valueColor={m.valueColor}
          valueSize={24}
          tileIcon={<Icon name={m.icon} size={18} stroke={1.7} />}
          tileBg={m.tileBg}
          tileColor={m.tileColor}
          sx={{ flex: 1, minWidth: 0 }}
        />
      ))}
    </Box>
  );
}
